// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j3-0";
export var fileCarousel = "_j3-2";
export var removeFileButton = "_j3-1";